import { createContext, useContext, useMemo } from 'react';
import { ThemeOptions } from 'lib/util/theming';

type PageSectionThemeContextValue = {
  theme: ThemeOptions;
};

const PageSectionThemeContext = createContext<PageSectionThemeContextValue | null>(null);

export const PageSectionThemeProvider = ({
  theme,
  children,
}: {
  theme: ThemeOptions;
  children: React.ReactNode;
}) => {
  const value = useMemo(() => ({ theme }), [theme]);
  return (
    <PageSectionThemeContext.Provider value={value}>{children}</PageSectionThemeContext.Provider>
  );
};

export const usePageSectionTheme = (): PageSectionThemeContextValue => {
  const context = useContext(PageSectionThemeContext);
  if (!context) {
    throw new Error('usePageSectionTheme must be used within a PageSectionThemeProvider');
  }
  return context;
};

export default PageSectionThemeContext;
